import { Grid } from "@material-ui/core/";
import MaterialTable from "material-table";
import React from "react";

const TableOnLog = (props) => {
	const { getDataTables, BaseUrl, tableRef, pageSize, state } = props;

	const columns = [
		{ title: "Waktu", field: "waktu" },
		{ title: "Nama", field: "nama" },
		{ title: "Keterangan", field: "keterangan" },
	];

	return (
		<Grid
			item
			direction="column-reverse"
			justifyContent="space-between"
			alignItems="stretch"
		>
			<Grid
				item
				style={{
					marginBottom: "20px",
					boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
				}}
			>
				<MaterialTable
					title="Log"
					tableRef={tableRef}
					columns={columns}
					data={getDataTables({
						url: `${BaseUrl}`,
						state: state,
						type: "listLog",
					})}
					options={{
						actionsColumnIndex: -1,
						paginationType: "stepped",
						pageSize: pageSize,
						pageSizeOptions: [10, 25, 50, 75, 100],
						headerStyle: {
							backgroundColor: "#67A3D5",
							color: "#FFF",
						},
					}}
				/>
			</Grid>
		</Grid>
	);
};

export default TableOnLog;
